import { Icon } from "@iconify-icon/react";
import React, { useState } from "react";

function Input({
  type,
  name,
  placeholder,
  error,
  touched,
  value,
  onBlur,
  onChange,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  return (
    <div className={`relative z-0 ${error ? "mt-4" : "mt-6"} `}>
      <input
        type={showPassword ? "text" : type}
        name={name}
        className={`peer block w-full appearance-none border-0 border-b border-primary bg-transparent px-0 py-1.5  text-sm text-primary focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-primary dark:text-primary dark:focus:border-blue-500 
          ${
            error &&
            touched &&
            "border-red-500 focus:border-red-500 dark:border-red-500 dark:focus:border-red-500"
          }`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />

      {type === "password" && (
        <p
          className="absolute top-0 text-lg cursor-pointer right-0"
          onClick={togglePasswordVisibility}>
          <Icon icon={showPassword ? "mdi:eye" : "mdi:eye-off"} />
        </p>
      )}
      {error && touched && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}

export default Input;
